export const urlAPI = '/api/tool-cabinet-configurator';


